import { isNumber, isNonNegativeNumber } from './NumberHelpers';
export const validateDurationPart = (input: number) =>
  !isNumber(input) || isNonNegativeNumber(input);

export const hasDuration = (
  hours?: number,
  minutes?: number,
  seconds?: number,
) =>
  isNonNegativeNumber(hours) ||
  isNonNegativeNumber(minutes) ||
  isNonNegativeNumber(seconds);

export const durationToSeconds = (
  hours?: number,
  minutes?: number,
  seconds?: number,
) =>
  (typeof hours === 'number' ? hours * 60 * 60 : 0) +
  (typeof minutes === 'number' ? minutes * 60 : 0) +
  (typeof seconds === 'number' ? seconds : 0);
